module.exports = __webpack_public_path__ + "assets/img/07-s.80a827a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/07-s.jpg
// module id = kiTz
// module chunks = 0